import {
  GhostrModule,
  IcapModule,
  NetworkSandboxingModule,
  SandboxManagerModule,
} from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface NetworkSandboxingModuleFormValue {
  uiSettings: { networkSandboxing: NetworkSandboxingModule };
}
export interface GhostrModuleFormValue {
  uiSettings: { ghostr: GhostrModule };
}
export interface IcapModuleFormValue {
  uiSettings: { icapSensor: IcapModule };
}
export interface SandboxManagerModuleFormValue {
  uiSettings: { sandboxManager: SandboxManagerModule };
}

export interface LocalSandboxFormValue {
  ip: string | null;
  hostname: string | null;
  endpointId: string | null;
}

// searchable keywords
export enum SandboxEndpointSensorSearchableKeywords {
  SandboxAnalyzer = 'SandboxAnalyzer',
  EndpointSensor = 'EndpointSensor',
  ConnectionSettings = 'ConnectionSettings',
  CloudSandboxAnalyzer = 'CloudSandboxAnalyzer',
  LocalSandboxAnalyzer = 'LocalSandboxAnalyzer',
  ProxyConfiguration = 'ProxyConfiguration',
  AutomaticSubmission = 'AutomaticSubmission',
  AnalysisMode = 'AnalysisMode',
  Monitoring = 'Monitoring',
  Blocking = 'Blocking',
  Remediation = 'Remediation',
  DefaultAction = 'DefaultAction',
  ContentPrefiltering = 'ContentPrefiltering',
  Exclusions = 'Exclusions',
  DoNotSubmit = 'DoNotSubmit',
  DetonationProfile = 'DetonationProfile',
}

export enum SandboxNetworkSensorSearchableKeywords {
  AutomaticSubmission = 'AutomaticSubmission',
  ConnectionSettings = 'ConnectionSettings',
  ContentPrefiltering = 'ContentPrefiltering',
  ProxyConfiguration = 'ProxyConfiguration',
  Exclusions = 'Exclusions',
  DoNotSubmit = 'DoNotSubmit',
  DetonationProfile = 'DetonationProfile',
}

export enum SandboxIcapSensorSearchableKeywords {
  AutomaticSubmission = 'AutomaticSubmission',
  ConnectionSettings = 'ConnectionSettings',
  ContentPrefiltering = 'ContentPrefiltering',
  ProxyConfiguration = 'ProxyConfiguration',
  Exclusions = 'Exclusions',
  DoNotSubmit = 'DoNotSubmit',
  DetonationProfile = 'DetonationProfile',
  SubmitFiles = 'SubmitFiles',
}

export enum SandboxManagerSearchableKeywords {
  SandboxManager = 'SandboxManager',
  PersistSamples = 'PersistSamples',
  DataRetention = 'DataRetention',
  AutomaticDelete = 'AutomaticDelete',
}
